module.exports = __webpack_public_path__ + "static/img/1000000473_blue.f53680a0.jpg";